import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';

import HelloModal from 'common/components/hello-modal';
import messages from './messages';
import { UserFileBase } from 'hellospa/page/prep-and-send/data/types/file';
import { setFilePassword, deleteFile } from 'hellospa/page/prep-and-send/data/actions/file';
import loading from './assets/legacy.gif';
import styles from './index.scss';
import { Dispatch } from 'hellospa/redux/types';

type Props = {
    file: UserFileBase,
}
const DocumentPassswordModal = ({ file } : Props) => {
  const intl = useIntl();
  const dispatch = useDispatch<Dispatch>();
  const { pwRequired, name, rootSnapshotGuid } = file;
  const [isOpen, setIsOpen] = useState(pwRequired);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const schema = Yup.object().shape({
    pdfPassword: Yup.string().trim()
      .required(intl.formatMessage(messages.passwordRequiredError)),
  });
  const handleClose = React.useCallback(() => {
    if (pwRequired) { // clicks cancel.
      dispatch(deleteFile(rootSnapshotGuid));
    }
    setIsOpen(false);
  }, [dispatch, pwRequired, rootSnapshotGuid]);

  useEffect(() => {
    setIsOpen(pwRequired);
  }, [pwRequired]);

  const verifyPassword = React.useCallback(async (password: string) => {
    const success = await dispatch(setFilePassword(password, rootSnapshotGuid));
    return success;

  }, [dispatch, rootSnapshotGuid]);

  const formik = useFormik({
    initialValues: {
      pdfPassword: '',
    },
    validationSchema: schema,
    validateOnBlur: true,
    onSubmit: async (values) => {
      setIsSubmitting(true);

      const success = await verifyPassword(values.pdfPassword);
      setIsSubmitting(false);
      if (success) {
        setIsOpen(false);
      } else {

        formik.setErrors({ pdfPassword: intl.formatMessage(messages.wrongPassword) });
      }
    },
  });

  return (
    <HelloModal
      isOpen={isOpen}
      contentLabel={intl.formatMessage(messages.title)}
      showCloseIcon={false}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      onRequestClose={handleClose}
      buttons={[
        {
          type: 'cancel',
          'data-qa-ref': 'cancel-document-password',
          text: intl.formatMessage(messages.cancel),
        },
        {
          type: 'primary',
          'data-qa-ref': 'submit-document-password',
          disabled: formik.errors && formik.errors.pdfPassword,
          text: intl.formatMessage(messages.submit),
          onClick: formik.submitForm,
        },
      ]}
    >
      {intl.formatMessage(messages.content, { documentName: name })}
      <form onSubmit={formik.handleSubmit}>
        <input
          name="pdfPassword"
          type='password'
          className={styles.pdfPassword}
          data-qa-ref='input-document-password'
          onBlur={formik.handleBlur}
          onChange={formik.handleChange} />
        { isSubmitting
          ? <img src={loading}
              className={styles.loadingSpinner}
              alt={intl.formatMessage(messages.loadingAltMessage)} />
          : formik.touched && formik.touched.pdfPassword
              && (
                <span className={styles.error}> {formik.errors.pdfPassword} </span>
              )
        }
      </form>
    </HelloModal>
  );
};

export default DocumentPassswordModal;
